import { AxiosResponse } from "axios";
import { axiosInstance, MessageResponse } from "./common";

export enum TypeOfInterest {
  FIXED = "FIXED",
  FLOATING = "FLOATING",
}

export const TYPE_OF_INTEREST_LABELS: Record<TypeOfInterest, string> = {
  [TypeOfInterest.FIXED]: "Fixed",
  [TypeOfInterest.FLOATING]: "Floating",
};

export interface CreditAccountDetails {
  account_number: string;
  original_sanction_amount?: number | null;
  account_opening_date?: string | null;
  branch_id?: string | null;
  exposure_credit_limit?: number | null;
  max_liability_exposure?: number | null;
  tenure_in_months?: number | null;
  type_of_interest?: TypeOfInterest | null;
  rate_of_interest?: number | null;
}

export interface UpdateCreditAccountDetailsRequest {
  original_sanction_amount?: number | null;
  account_opening_date?: string | null;
  branch_id?: string | null;
  exposure_credit_limit?: number | null;
  max_liability_exposure?: number | null;
  tenure_in_months?: number | null;
  type_of_interest?: TypeOfInterest | null;
  rate_of_interest?: number | null;
}

export const CreditAccountDetailsAPI = {
  update: async (
    case_id: string,
    account_number: string,
    request: UpdateCreditAccountDetailsRequest
  ) => {
    const response: AxiosResponse<MessageResponse> =
      await axiosInstance.patch(
        `/v1/cases/${case_id}/credit-accounts/${account_number}/credit-account-details`,
        request
      );

    return response.data;
  },
};